import request from '@/utils/request'

let VisionApi = {
  /*获取数据*/
  getData(data) {
    return request._get('/shop/plus.vision.vision/index', data);
  },


  /*视力数据列表*/
  /*用户拍卖列表*/
  getVisionList(data) {
    return request._post('/shop/plus.vision.vision/index', data);
  },
  /* 省列表 */
  provinceList(data) {
    return request._get('/shop/plus.vision.vision/provinceList', data);
  },
  /* 市列表 */
  city_list(data) {
    return request._get('/shop/plus.vision.vision/cityList', data);
  },
  /* 区域列表 */
  region_list(data) {
    return request._get('/shop/plus.vision.vision/regionList', data);
  },

  /*获取视力数据信息*/
  visionDetail(data) {
    return request._post('/shop/plus.vision.vision/visionDetail', data);
  },
  /*修改视力数据*/
  editVision(data) {
    return request._post('/shop/plus.vision.vision/edit', data);
  },
  /*删除视力数据*/
  deleteVision(data) {
    return request._post('/shop/plus.vision.vision/delete', data);
  },

  /*管理员列表*/
  userList(data) {
    return request._post('/shop/plus.vision.manager/index', data);
  },
  /*添加管理员需要的数据*/
  userAddInfo(data) {
    return request._post('/shop/plus.vision.manager/addInfo', data);
  },
  /*添加管理员*/
  userAdd(data) {
    return request._post('/shop/plus.vision.manager/add', data);
  },
  /*修改管理员需要的数据*/
  userEditInfo(data) {
    return request._get('/shop/plus.vision.manager/edit', data);
  },
  /*修改管理员*/
  userEdit(data) {
    return request._post('/shop/plus.vision.manager/edit', data);
  },
  /*删除管理员*/
  userDelete(data) {
    return request._post('/shop/plus.vision.manager/delete', data);
  },
  /*删除管理员*/
  auth(data) {
    return request._post('/shop/plus.vision.vision/auth', data);
  },


}
export default VisionApi;



// WEBPACK FOOTER //
// ./src/api/vision.js